/**
 * Auth flow status enum representing all possible steps in the authentication flow
 */
export enum AuthFlowStatus {
  /** Initial questionnaire for patient onboarding */
  QUESTIONNAIRE = "questionnaire",
  
  /** Doctor preview screen (blurred card to encourage registration) */
  DOCTOR_PREVIEW = "doctor-preview",
  
  /** User registration or login */
  REGISTRATION = "registration",
  
  /** User information completion (name, personal details) */
  USER_INFORMATION = "user-information",
  
  /** Doctor selection step for patients */
  DOCTOR_MATCHING = "doctor-matching",
  
  /** Psychologist selection step for patients */
  PSYCHO_MATCHING = "psycho-matching",
  
  /** Clinic selection step for patients */
  CLINIC_MATCHING = "clinic-matching",
  
  /** Team ready message step for patients */
  TEAM_READY = "team-ready",
  
  /** Pathway creation step for patients */
  PATHWAY_INITIALIZATION = "pathway-initialization",
  
  /** First consultation booking step for patients */
  FIRST_BOOKING_CONSULTATION = "first-booking-consultation",
  
  /** Flow completed successfully */
  COMPLETED = "completed",
}